import React, { FC } from "react";

const Home: FC = () => {
  console.log("Renderizou HOME");

  return <div>Home</div>;
};

export default Home;
